import { useRef } from 'react';
import { longItems } from '@/mocks/gossip';

export default function LongGallery() {
  const rail = useRef<HTMLDivElement>(null);

  const scroll = (dir: 1 | -1) => {
    rail.current?.scrollBy({ left: dir * 260, behavior: 'smooth' });
  };

  return (
    <section id="changtu" className="border-y border-background-200 bg-background-100/60 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 text-xs font-semibold tracking-widest text-accent-700">
              <span className="h-px w-6 bg-accent-500" />
              LONG IMAGE
            </p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">长图合集 · 八卦长图全收录</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              把热门事件整理成一页页可长按保存、方便分享的图文长图，左右滑动慢慢看，吃瓜也能有条理。
            </p>
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              aria-label="上一组长图"
              onClick={() => scroll(-1)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-700 transition hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-arrow-left-line" />
            </button>
            <button
              type="button"
              aria-label="下一组长图"
              onClick={() => scroll(1)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-700 transition hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>

        <div ref={rail} className="hide-scrollbar -mx-1 flex snap-x snap-mandatory gap-5 overflow-x-auto px-1 pb-2">
          {longItems.map((it) => (
            <article
              key={it.id}
              className="group relative aspect-[2/3] w-[210px] shrink-0 snap-start overflow-hidden rounded-xl bg-secondary-100 md:w-[230px]"
            >
              <img
                src={it.img}
                alt={it.alt}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-foreground-950/20" />
              <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-[10px] font-semibold text-primary-700 backdrop-blur">
                <i className="ri-arrow-up-circle-line" />
                {it.tag}
              </span>
              <span className="absolute right-3 top-3 rounded-full bg-foreground-950/45 px-2 py-0.5 text-[10px] text-background-50 backdrop-blur">
                {it.count} 图
              </span>
              <div className="absolute inset-x-0 bottom-0 p-4">
                <h3 className="line-clamp-2 text-[15px] font-bold leading-snug text-background-50">{it.title}</h3>
                <span className="mt-2 inline-flex items-center gap-1 text-[11px] text-accent-200">
                  长按保存 · 点开即看
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </article>
          ))}
        </div>
        <p className="mt-3 text-center text-[11px] text-foreground-500">
          长图内容为编辑部基于公开素材重排，如涉及需调整的内容请联系我们。
        </p>
      </div>
    </section>
  );
}